<template>
  <div class="mb-4 p-3 bg-gray-50">
    <div class="text-lg mb-4 font-bold">
      {{ displayName }}
    </div>
    <label>
      <span class="sr-only">Filter {{ displayName }}</span>
      <input
        v-if="showFilter"
        v-model="filterValue"
        type="text"
        class="mb-2 w-full px-2 py-1 border border-gray-200"
        placeholder="Filter..."
      >
    </label>
    <div>
      <label
        v-for="([label, count]) in visibleItems"
        :key="label"
        class="flex gap-2 text-gray-900 mb-2 cursor-pointer"
      >
        <input
          type="checkbox"
          class="mt-1"
          :checked="isActive(label)"
          @change="toggleFacet(label)"
        >
        <span>{{ label }} ({{ count.toLocaleString() }})</span>
      </label>
    </div>
    <div
      v-if="items.length > 7"
      class="border-t mt-4 pt-2"
    >
      <button
        class="link link-primary link-red link-cta uppercase bg-transparent border-none cursor-pointer"
        :class="expanded ? 'link-cta-up' : 'link-cta-down'"
        @click.prevent="toggleExpand"
      >
        {{ expanded ? 'Show less' : 'Show more' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'

const props = defineProps<{
  facetName: string
  facetObj: Record<string, number>
  selected: string[]
  expanded: boolean
}>()

const emit = defineEmits<{
  (e: 'update:selected', value: string): void
  (e: 'update:expanded', value: boolean): void
}>()

const facetDisplayNames: Record<string, string> = {
  AssetTypeName: 'Asset Type',
  sei_year_published: 'Year Published',
  sei_topic: 'Topic',
  sei_author: 'Author',
}

const displayName = computed(() => facetDisplayNames[props.facetName] || props.facetName)
const items = computed(() => Object.entries(props.facetObj))
const filterValue = ref('')
const showFilter = computed(() => items.value.length > 7)

const filteredItems = computed(() => {
  if (!showFilter.value || !filterValue.value.trim()) return items.value
  const val = filterValue.value.trim().toLowerCase()
  return items.value.filter(([label]) => label.toLowerCase().includes(val))
})

const visibleItems = computed(() => {
  const items = [...filteredItems.value] // make a copy
  // Show newest first
  if (props.facetName == 'sei_year_published'){
    items.reverse();
  }
  // Remove "None" option if present.
  for (const i in items) {
    if (items[i][0].toLowerCase() === 'none') {
      items.splice(Number(i), 1);
      break;
    }
  }
  return props.expanded ? items : items.slice(0, 7)
})

function isActive(label: string) {
  return props.selected.includes(label)
}

function toggleFacet(label: string) {
  emit('update:selected', label)
}

function toggleExpand() {
  emit('update:expanded', !props.expanded)
}
</script>
